import { Button } from '@avanta/shared/components/ui/Button';
import { Card } from '@avanta/shared/components/ui/Card';
import { X } from 'lucide-react';
import { type ReactElement } from 'react';
import { TagList } from 'components/TagList';
import { type SurveyCardProps } from './types';

export const SurveyCard = ({
  title,
  subtitle,
  tags,
  onClose,
  children,
}: SurveyCardProps): ReactElement => (
  <Card>
    <div className="flex flex-col gap-8 w-full justify-between">
      {onClose && (
        <Button icon="only" variant="ghost" className="absolute self-end p-2" onClick={onClose}>
          <X />
        </Button>
      )}
      <div className="flex flex-col gap-2">
        {title && <h2 className="text-lg font-semibold">{title}</h2>}
        {subtitle && <p className="text-sm text-gray-600">{subtitle}</p>}
        <TagList tagsText={tags} direction="horizontal" />
      </div>
      {children}
    </div>
  </Card>
);
